var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApple(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", null, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148618",
    "data-name": "Rectangle 148618",
    width: 24,
    height: 24,
    transform: "translate(0.175 0.089)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "apple",
    transform: "translate(-0.175 -0.089)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "apple-black-logo",
    transform: "translate(2.776 0.65)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11756",
    "data-name": "Group 11756",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8919",
    "data-name": "Path 8919",
    d: "M61.871,128.305c-.628-3.158,2.37-5.011,2.37-5.011a5.728,5.728,0,0,0-3.131-2.124,5.457,5.457,0,0,0-3.924.517,4.37,4.37,0,0,1-1.47.409c-1.416,0-2.45-1.5-5.148-.816a6.36,6.36,0,0,0-4.168,5.174,14.032,14.032,0,0,0,1.88,8.362c1.47,2.535,2.968,3.487,4.032,3.515s2.124-.762,3.4-.954,2.069.464,3.325.817,1.69.025,3.131-1.2,2.753-4.741,2.753-4.741A5.077,5.077,0,0,1,61.871,128.305Z",
    transform: "translate(-46.315 -115.517)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8920",
    "data-name": "Path 8920",
    d: "M255.389,3.61A4.318,4.318,0,0,0,256.308,0a6.659,6.659,0,0,0-3.26,1.7,4.907,4.907,0,0,0-1.091,3.513A6.142,6.142,0,0,0,255.389,3.61Z",
    transform: "translate(-242.612 0)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.93557d19.svg";
export { ForwardRef as ReactComponent };